export default __webpack_public_path__ + "static/media/check_box_outline_blank_black_24dp.e5a9d6f8.svg";